<template>
  <div class="compress">
    <div class="config">
      <div class="top-select flex-start">
        <div class="config-item flex-start">
          <span class="title mr10">选择尺寸</span>
          <el-select
            v-model="size"
            placeholder="请选择"
            popper-class="form-select"
            :popper-append-to-body="false"
            size="small"
            style="width: 128px"
            @change="getPicSize"
          >
            <el-option value="origin" label="保持原始尺寸">保持原始尺寸</el-option>
            <el-option value="pc" label="适合电脑尺寸">适合电脑尺寸</el-option>
            <el-option value="mobile" label="适合手机尺寸">适合手机尺寸</el-option>
          </el-select>
        </div>
        <div class="config-item flex-start">
          <span class="title">宽(像素)</span>
          <el-input v-model="options.width" @input="handleWidthInput" size="small" style="width: 80px"></el-input>
        </div>
        <div class="config-item flex-start">
          <span class="title">高(像素)</span>
          <el-input v-model="options.height" @input="handleHeightInput" size="small" style="width: 80px"></el-input>
        </div>
      </div>
      <div class="item flex-start">
        <div class="config-item flex-start">
          <span class="title">压缩等级</span>
          <el-input
            v-model="options.level"
            @input="handleLevelInput"
            size="small"
            style="width: 100px"
            placeholder="1-10000"
          ></el-input>
          <!-- <el-select
            v-model="options.level"
            placeholder="请选择"
            popper-class="form-select"
            :popper-append-to-body="false"
            size="small"
            style="width: 80px"
          >
            <el-option v-for="item in 100" :key="item" :value="item" :label="item">{{ item }}</el-option>
          </el-select> -->
          <span class="or">或</span>
          <span class="title">控制大小</span>
          <el-tooltip effect="dark" content="如果填了控制大小，则压缩等级不生效" placement="top">
            <el-input v-model="options.size" @input="handleSizeInput" size="small" style="width: 60px"></el-input>
          </el-tooltip>
          <span class="kb">KB以内</span>
        </div>
        <!-- <div class="config-item flex-start">
          <span class="title">是否渐进显示</span>
          <el-switch v-model="options.progressive"></el-switch>
        </div> -->

        <div class="config-item flex-start">
          <span class="title">分包数量</span>
          <el-input v-model="options.packageNum" @input="handleInput" size="small" style="width: 60px"></el-input>
          <!-- <el-tooltip effect="dark" content="最多分成10包" placement="top">
            <el-input v-model="options.packageNum" @input="handleInput" size="small" style="width: 60px"></el-input>
          </el-tooltip> -->
          <span class="ml10">包</span>
        </div>

        <div class="config-item">
          <button class="common-btn" @click="startCompress">开始压缩</button>
        </div>
      </div>
    </div>
    <div
      class="upload"
      v-if="!showPreview"
      @drop.prevent="addFile"
      @dragover.prevent="setDragOver"
      @dragleave.prevent="setDragLeave"
      :style="`border: 5px dashed ${isDrag ? '#409EFF' : '#d4d4d3'};`"
      v-loading="loadPriview"
      element-loading-text="上传中..."
    >
      <label for="uploadPic" class="label-content">
        <el-button type="primary">选择图片压缩</el-button>
        <p class="mt10">支持处理JPG/PNG/BMP格式。单张图片最大支持30M。</p>
        <input
          ref="files"
          id="file"
          type="file"
          name="uploadPic"
          accept="image/jpeg,image/bmp,image/png"
          @change="previewFiles"
        />
      </label>
    </div>

    <div class="preview" v-if="showPreview">
      <div class="preview-wrapper" v-loading="loadPriview" element-loading-text="上传中...">
        <div class="left-pannel">
          <!-- <h3>原图</h3> -->
          <div class="origin-content img-item">
            <div class="left-item">
              <img @click="openViewer(originInfo.fileId)" :src="previewSrc" alt="" />
            </div>
            <div class="right-item">
              <p>
                <span class="title">图片格式:</span>
                <span class="value">{{ originInfo.format }}</span>
              </p>
              <p class="mt10">
                <span class="title">源文件:</span>
                <span class="value">{{ originInfo.size }} KB</span>
              </p>
              <p class="mt10">
                <span class="title">源尺寸:</span>
                <span class="value">{{ originInfo.width }} x {{ originInfo.height }}</span>
              </p>
              <div class="reUpload">
                <label for="reUpload">
                  <button class="common-btn uploadBtn">重新上传图片</button>
                  <input
                    ref="files"
                    id="file"
                    type="file"
                    name="reUpload"
                    accept="image/jpeg,image/bmp,image/png"
                    @change="reUpload"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="loading">
          <span class="loader"></span>
        </div> -->
        <!-- <div class="line"></div> -->
        <div class="right-pannel">
          <!-- <h3>压缩后</h3> -->
          <div class="after-compress img-item">
            <div class="left-item">
              <img
                v-if="compressResult.decompFileId"
                @click="openViewer(compressResult?.decompFileId)"
                :src="`${baseUrl}/api/console/image/${compressResult.decompFileId}`"
              />
              <div class="loading" v-if="compressResult.decompFileId && compressResult.status == 0">
                <span class="loader"></span>
              </div>
              <div v-if="!compressResult.decompFileId" class="no-img">
                <div class="loading" v-if="isCompress">
                  <span class="loader"></span>
                </div>
              </div>
            </div>
            <div class="right-item">
              <p class="flex-start">
                <span class="title">解压缩结果:</span>
                <span class="value redColor mr5" v-if="compressResult.status == 2">
                  {{ statusResult[compressResult.status] }}
                </span>
                <span class="value" v-else>{{ statusResult[compressResult.status] }}</span>
                <span class="value redColor" v-if="compressResult.status == 2">{{ compressResult.errorMsg }}</span>
                <a v-if="compressResult.status == 2" @click.prevent="openFeedback" class="ml10">点击反馈</a>
              </p>
              <p class="mt10">
                <span class="title">压缩等级:</span>
                <span class="value">{{ compressResult.level }}</span>
              </p>
              <p class="mt10">
                <span class="title">压缩文件格式:</span>
                <span class="value">JP2</span>
              </p>
              <p class="mt10 flex-start">
                <span class="title">压缩后文件大小:</span>
                <span class="value">{{ compressResult.compSize || 0 }} KB</span>
                <a
                  v-if="compressResult.compFileId"
                  class="ml10"
                  :href="`${baseUrl}/api/console/image/${compressResult.compFileId}`"
                  download
                >
                  点击下载
                </a>
              </p>
              <p class="mt10 flex-start" v-if="options.progressive">
                <span class="title">总包数:</span>
                <span class="value">{{ compressResult.packageNum || 0 }}</span>
                <a v-if="compressResult?.historyImageFileIds?.length > 0" class="ml10" @click.prevent="openHistory">
                  查看历史图片
                </a>
              </p>
              <p class="mt10 flex-start" v-if="options.progressive">
                <span class="title">每包大小:</span>
                <span class="value">{{ compressResult.packageSize || 0 }} KB</span>
              </p>
              <p class="mt10 flex-start">
                <span class="title">解压后大小:</span>
                <span class="value">{{ compressResult.decompFileSize || 0 }} KB</span>
              </p>
              <p class="mt10 flex-start">
                <span class="title">解压后尺寸:</span>
                <span class="value">
                  {{ compressResult.decompWidth || 0 }} x {{ compressResult.decompHeight || 0 }}
                </span>
              </p>
              <p class="mt10 flex-start">
                <span class="title">PSNR值:</span>
                <span class="value">{{ compressResult.psnr || 0 }} dB</span>
              </p>
              <p class="mt10 flex-start" v-if="compressResult.decompFileId">
                <a :href="`${baseUrl}/api/console/image/${compressResult.decompFileId}`" class="common-btn uploadBtn">
                  保存图片
                </a>
                <a @click.prevent="openViewer(compressResult?.decompFileId)" class="ml10">查看预览</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 预览图片 -->
    <el-image-viewer
      v-if="showViewer"
      :on-close="
        () => {
          showViewer = false;
        }
      "
      :url-list="imgList"
    />

    <album ref="album" />
    <feedback ref="feedback"></feedback>
  </div>
</template>

<script>
import { getPreviewImageInfo } from '@/utils/common';
import { uploadImg, startCompress, getCompressPic, getCompressResult } from '@/api/api';
import { validNumber } from '@/utils/validate';
export default {
  // inject: ['reload'],
  data() {
    return {
      showPreview: false,
      previewSrc: '',
      options: {
        fileId: '',
        size: 0,
        width: '',
        height: '',
        level: 80,
        progressive: false,
        packageNum: 0,
      },
      originInfo: {},
      size: 'origin',
      compressResult: {},
      statusResult: {
        0: '执行中',
        1: '成功',
        2: '失败',
      },
      baseUrl: this.$baseUrl,
      showViewer: false,
      imgList: [],
      isCompress: false,
      isDrag: false,
      loadPriview: false,
    };
  },
  methods: {
    reUpload(e) {
      this.previewFiles(e);
    },

    valideFile(file) {
      let fileType = ['image/jpeg', 'image/bmp', 'image/png'];

      // 限制文件类型
      if (!fileType.includes(file.type)) {
        this.$message.error('只支持上传JPG,BMP,PNG格式的图片');
        this.isDrag = false;
        return false;
      }

      // 单张图片最大30M
      if (file.size > 31457280) {
        this.$message.error('单张图片最大30M');
        this.isDrag = false;
        return false;
      }

      return true;
    },

    addFile(e) {
      let files = [...e.dataTransfer.files];
      // 不支持多选
      if (files?.length > 1) {
        this.$message.error('单次只能上传一张图片');
        this.isDrag = false;
        return false;
      }
      let file = files[0];
      let isValid = this.valideFile(file);
      if (isValid) {
        console.log('addFile ~ file', file);
        this.uploadFile(files[0]);
        this.isDrag = false;
      }
    },

    setDragOver() {
      this.isDrag = true;
    },
    setDragLeave() {
      this.isDrag = false;
    },
    getPicSize(val) {
      let rate = this.originInfo.width / this.originInfo.height;
      let isRate = Number.isNaN(rate);
      if (val == 'origin') {
        this.options.width = this.originInfo.width;
        if (!isRate) {
          this.options.height = this.originInfo.height;
        }
      }

      if (val == 'pc') {
        this.options.width = 1024;
        if (!isRate) {
          this.options.height = Math.floor(1024 / rate);
        }
      }
      if (val == 'mobile') {
        this.options.width = 480;
        if (!isRate) {
          this.options.height = Math.floor(480 / rate);
        }
      }
    },

    async uploadFile(file) {
      this.loadPriview = true;
      try {
        let defaultOptions = {
          fileId: '',
          size: 0,
          width: '',
          height: '',
          level: 80,
          progressive: false,
          packageNum: 0,
        };
        this.options = defaultOptions;
        this.compressResult = {};
        // const fileInfo = await getPreviewImageInfo(file);
        // this.previewSrc = fileInfo.imgSrc;
        const formData = new FormData();
        formData.append('image', file);
        const remoteUploadInfo = await uploadImg(formData);
        this.originInfo = remoteUploadInfo.data;
        this.options.width = this.originInfo.width;
        this.options.height = this.originInfo.height;
        this.options.fileId = this.originInfo.fileId;
        this.previewSrc = `${this.baseUrl}/api/console/image/${this.originInfo.fileId}`;
        this.size = 'origin';
        this.showPreview = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.loadPriview = false;
        this.$refs.files.value = '';
      }
    },

    // 上传预览图片
    async previewFiles(e) {
      try {
        let file = e.target.files[0];
        let isValid = this.valideFile(file);
        if (isValid) {
          this.uploadFile(file);
        }
      } catch (error) {
        console.log(error);
      }
    },

    // 压缩图片
    async startCompress() {
      if (!this.options?.fileId) {
        this.$message.error('请先上传图片');
        return false;
      }
      try {
        this.isCompress = true;
        const formData = new FormData();
        let options = this.options;
        for (let key in options) {
          formData.append(key, options[key]);
        }
        const res = await startCompress(formData);
        console.log({ res });
        if (res.code == 0) {
          this.compressResult = res.data;
          if (this.compressResult?.status == 0) {
            this.getCompressResult();
          }
        }
      } catch (error) {
        this.isCompress = false;
        console.log(error);
      }
    },

    async getCompressResult() {
      try {
        const res = await getCompressResult(this.compressResult?.fileId);
        this.compressResult = res.data;
        console.log(this.compressResult.decompFileId);
        if (this.compressResult?.status == 0) {
          let timer = setTimeout(() => {
            this.getCompressResult();
            clearTimeout(timer);
          }, 2000);
        } else {
          this.isCompress = false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    openFeedback() {
      this.$refs.feedback.open(this.compressResult?.fileId);
    },
    openViewer(id) {
      // this.compressResult?.decompFileId
      this.imgList = [`${this.baseUrl}/api/console/image/${id}`];
      this.showViewer = true;
    },
    openHistory() {
      let historyArray = this.compressResult?.historyImageFileIds;
      let psnrList = this.compressResult?.psnrs;
      let urlList = historyArray.map((item) => {
        item = `${this.baseUrl}/api/console/image/${item}`;
        return item;
      });
      const result = [];
      for (let i = 0; i < urlList.length; i++) {
        result.push({ imgSrc: urlList[i], psnr: psnrList[i] });
      }
      // console.log(result);
      this.$refs.album.open(result,urlList);
    },
    handleInput() {
      if (!validNumber(this.options.packageNum)) {
        this.options.packageNum = '';
      } else {
        if (this.options.packageNum >= 1) {
          this.options.progressive = true;
        } else {
          this.options.progressive = false;
        }
        // if (this.options.packageNum > 10) {
        //   this.$message.warning('最多分成10包');
        //   this.options.packageNum = 10;
        // }
      }
    },
    handleSizeInput() {
      if (!validNumber(this.options.size)) {
        this.options.size = '';
      } else {
        if (this.options.size > 1024) {
          this.$message.warning('控制大小不能超过1024KB');
          this.options.size = 1024;
        }
      }
    },
    handleLevelInput() {
      if (!validNumber(this.options.level)) {
        this.options.level = '';
      } else {
        if (this.options.level < 1 || this.options.level > 10000) {
          this.$message.warning('压缩等级范围为1-10000');
          this.options.level = '';
        }
      }
    },
    handleWidthInput() {
      if (!validNumber(this.options.width)) {
        this.options.width = '';
      }
    },
    handleHeightInput() {
      if (!validNumber(this.options.height)) {
        this.options.height = '';
      }
    },
  },
  components: {
    feedback: () => import('./feedback.vue'),
    album: () => import('./album.vue'),
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
};
</script>

<style lang="scss" scoped>
.compress {
  width: 100%;
  height: 440px;
  box-sizing: border-box;
  color: #0d0e24;
  // box-shadow: rgba(17, 12, 46, 0.15) 0px 48px 100px 0px;
  padding: 20px;
  // margin-top: 30px;
  font-size: 12px;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  .upload {
    cursor: pointer;
    width: 100%;
    min-height: 300px;
    position: relative;
    // border: 5px dashed #d4d4d3;
    label {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
      text-align: center;
      border-radius: 2px;
      overflow: hidden;
      p {
        color: #a5a3a8;
        font-weight: 600;
        font-size: 14px;
      }
      input {
        position: absolute;
        top: 0;
        display: block;
        opacity: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
  }
  .config {
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .item {
      margin-bottom: 24px;
      .config-item {
        // margin-right: 10px;
        .title {
          display: inline-block;
          margin-right: 10px;
          white-space: nowrap;
        }
        &::v-deep {
          .el-popper[x-placement^='bottom'] .popper__arrow {
            border-bottom-color: #fff !important;
          }
          .el-popper[x-placement^='bottom'] .popper__arrow::after {
            border-bottom-color: #fff !important;
          }
        }
      }
    }
    .top-select {
      margin-bottom: 20px;
      .title {
        margin-right: 10px;
      }
    }
    .config-item {
      margin-right: 12px;
    }
  }

  .preview {
    width: 100%;
    // height: 250px;
    padding: 10px;
    .preview-wrapper {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .left-pannel {
        width: 48%;
        .origin {
          width: 100%;
          margin-top: 20px;
        }
      }
      .right-pannel {
        width: 48%;
        position: relative;
      }
      h3 {
        font-size: 16px;
        text-align: center;
        font-weight: 600;
      }
      .img-item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
        .left-item {
          position: relative;
          img {
            max-height: 300px;
            max-width: 300px;
            cursor: pointer;
          }
          .no-img {
            position: relative;
            width: 300px;
            height: 300px;
            border: 1px solid #d4d4d3;
          }
        }
        .right-item {
          margin-left: 20px;
          font-size: 12px;
          color: #333;
          .title {
            display: inline-block;
            font-weight: 400;
            margin-right: 10px;
            white-space: nowrap;
            // min-width: 80px;
          }
          .value {
            display: inline-block;
            white-space: nowrap;
            font-weight: 600;
          }
        }
      }
      .mw60 {
        min-width: 60px !important;
      }
    }
    a {
      display: inline-block;
      color: #226bfb;
      cursor: pointer;
      text-decoration: none;
      white-space: nowrap;
    }
  }
}
.or {
  margin-left: 5px;
  margin-right: 5px;
}

.common-btn {
  display: inline-block;
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-decoration: none;
  text-align: center;
  border: none;
  outline: none;
  color: #fff;
  background: linear-gradient(219deg, #788bf9, #1f92f9, #349cc8);
  border-radius: 16px;
  color: #fff !important;
}
.redColor {
  color: #f56c6c;
}
.loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  .loader {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid #226bfb;
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 0.5s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
.kb {
  display: inline-block;
  white-space: nowrap;
  margin-left: 10px;
}

.reUpload {
  width: 120px;
  height: 32px;
  position: relative;
  margin-top: 10px;
  label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    border-radius: 2px;
    overflow: hidden;
    input {
      position: absolute;
      top: 0;
      display: block;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
  button {
    font-size: 12px;
  }
}
</style>